// custom typefaces
import 'typeface-source-sans-pro'

// import "prismjs/themes/prism.css"
import './src/utils/global.css'

require('katex/dist/katex.min.css')
